(function(){
  function setup(root){
    if(root.__owcaCar)return;root.__owcaCar=true;
    var prev=root.querySelector('[data-owca-car-prev]'),next=root.querySelector('[data-owca-car-next]'),all=root.querySelector('[data-owca-car-all]');
    var tracks=Array.prototype.slice.call(root.querySelectorAll('[data-owca-car-track]'));
    var tabs=Array.prototype.slice.call(root.querySelectorAll('[data-owca-tab]'));
    if(!tracks.length)return;
    function active(){for(var i=0;i<tracks.length;i++){if(!tracks[i].hidden)return tracks[i]}return tracks[0]}
    function step(t){var card=t.querySelector('.owca-card');if(!card)return t.clientWidth;var gap=parseFloat(getComputedStyle(t).columnGap)||0;var w=card.getBoundingClientRect().width+gap;return Math.max(1,Math.floor((t.clientWidth+gap)/w))*w}
    function update(){var t=active();var max=t.scrollWidth-t.clientWidth-2;if(prev)prev.disabled=t.scrollLeft<=2;if(next)next.disabled=t.scrollLeft>=max}
    if(prev)prev.addEventListener('click',function(){var t=active();t.scrollBy({left:-step(t),behavior:'smooth'})});
    if(next)next.addEventListener('click',function(){var t=active();t.scrollBy({left:step(t),behavior:'smooth'})});
    tracks.forEach(function(t){t.addEventListener('scroll',function(){window.requestAnimationFrame(update)},{passive:true})});
    function select(btn,focus){
      tabs.forEach(function(b){var on=b===btn;b.setAttribute('aria-selected',on?'true':'false');b.tabIndex=on?0:-1});
      var id=btn.getAttribute('data-owca-tab');
      tracks.forEach(function(t){t.hidden=t.id!==id});
      var t=active();t.scrollLeft=0;
      if(all&&t.getAttribute('data-all'))all.href=t.getAttribute('data-all');
      if(focus)btn.focus();
      update();
    }
    tabs.forEach(function(b,i){
      b.addEventListener('click',function(){select(b)});
      b.addEventListener('keydown',function(e){var k=e.key;if(k!=='ArrowRight'&&k!=='ArrowLeft')return;e.preventDefault();var n=(i+(k==='ArrowRight'?1:-1)+tabs.length)%tabs.length;select(tabs[n],true)});
    });
    window.addEventListener('resize',update);
    update();
  }
  function all(){document.querySelectorAll('[data-owca-car]').forEach(setup)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',all)}else{all()}
  document.addEventListener('shopify:section:load',all);
})();